export const ReportReusageCodes = {
    CREATE_NEW: 'CREATE_NEW',
    DENY_CREATION_24_HOURS: 'DENY_CREATION_24_HOURS',
    VIEW_EXISTING_REPORT: 'VIEW_EXISTING_REPORT',
    REPORT_IN_PROGRESS: 'REPORT_IN_PROGRESS',
};
